<template>
  <AppDialog :is-open="isDialogOpened"
             size="l"
             @cancel="closeDialog"
  >
    <template #title>{{ $t('archives.steps.ArchivesAddWarningDialog.title') }}</template>

    <template #body>
      <p>{{ $t("archives.steps.ArchivesAddWarningDialog.warning") }}</p>
      <p class="mb-0">{{ $t("archives.steps.ArchivesAddWarningDialog.confirmText") }}</p>
    </template>

    <template #footer>
      <v-checkbox
        v-model="doNotRemindMe"
        :label="$t('archives.steps.ArchivesAddWarningDialog.doNotRemindMeCheckboxLabel')"
        class="mt-0 pt-0"
        hide-details
      />
      <v-spacer />
      <app-button
        type="outlined"
        variant="neutral"
        @click="closeDialog"
      >
        {{ $t('common.cancel') }}
      </app-button>
      <app-button
        @click="confirmClick"
      >
        {{ $t('common.confirm') }}
      </app-button>
    </template>
  </AppDialog>
</template>

<script>
import { defineComponent } from 'vue'

import { useArchivesStore } from '@/stores/archivesStore'

import AppDialog from '../../common/dialogs/AppDialog.vue'
import { dialogMixin } from '../../mixins/dialogMixin'

export default defineComponent({
  name: 'ArchivesAddWarningDialog',
  components: { AppDialog },
  mixins: [dialogMixin],
  emits: ['confirm', 'close'],
  setup() {
    const archivesStore = useArchivesStore()
    return { archivesStore }
  },
  data () {
    return {
      doNotRemindMe: false,
    }
  },
  methods: {
    confirmClick () {
      this.$emit('confirm')
      if (this.doNotRemindMe) {
        this.archivesStore.setMuteArchivingWarning(true)
      }
      this.closeDialog()
    },
  },
})
</script>
